const EXT_TO_MIME: Record<string, string> = {
  jpg: 'image/jpeg', jpeg: 'image/jpeg', png: 'image/png', gif: 'image/gif',
  webp: 'image/webp', svg: 'image/svg+xml', avif: 'image/avif', heic: 'image/heic',
  bmp: 'image/bmp', ico: 'image/x-icon',
  mp4: 'video/mp4', mov: 'video/quicktime', webm: 'video/webm', mkv: 'video/x-matroska',
  avi: 'video/x-msvideo', '3gp': 'video/3gpp',
  mp3: 'audio/mpeg', wav: 'audio/wav', ogg: 'audio/ogg', opus: 'audio/opus',
  m4a: 'audio/mp4', aac: 'audio/aac', flac: 'audio/flac',
  pdf: 'application/pdf',
  doc: 'application/msword',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  xls: 'application/vnd.ms-excel',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  ppt: 'application/vnd.ms-powerpoint',
  pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  txt: 'text/plain', csv: 'text/csv', json: 'application/json', xml: 'application/xml',
  html: 'text/html', htm: 'text/html', md: 'text/markdown',
  zip: 'application/zip', tar: 'application/x-tar', gz: 'application/gzip',
  '7z': 'application/x-7z-compressed', rar: 'application/x-rar-compressed'
};

export function getExtension(filename: string): string {
  const dot = filename.lastIndexOf('.');
  return dot === -1 || dot === filename.length - 1 ? '' : filename.slice(dot + 1).toLowerCase();
}

export function getMimeType(input: string | File | Blob): string {
  if (typeof input === 'string') {
    const ext = getExtension(input);
    return EXT_TO_MIME[ext] ?? 'application/octet-stream';
  }
  if ('type' in input && input.type) return input.type;
  if ('name' in input) {
    const ext = getExtension((input as File).name);
    return EXT_TO_MIME[ext] ?? 'application/octet-stream';
  }
  return 'application/octet-stream';
}

export type MimeCategory = 'image' | 'video' | 'audio' | 'document' | 'archive' | 'text' | 'other';

export function mimeCategory(mime: string): MimeCategory {
  if (mime.startsWith('image/')) return 'image';
  if (mime.startsWith('video/')) return 'video';
  if (mime.startsWith('audio/')) return 'audio';
  if (mime.startsWith('text/')) return 'text';
  if (mime === 'application/pdf' || /word|sheet|presentation|msword|excel|powerpoint/.test(mime)) return 'document';
  if (/zip|tar|gzip|rar|7z/.test(mime)) return 'archive';
  return 'other';
}

const ICONS: Record<MimeCategory, string> = {
  image: '🖼️',
  video: '🎬',
  audio: '🎵',
  document: '📄',
  archive: '🗜️',
  text: '📝',
  other: '📎'
};

export function mimeToIcon(mime: string): string {
  return ICONS[mimeCategory(mime)];
}
